'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SearchField = require('./SearchField.scss');

var _SearchField2 = _interopRequireDefault(_SearchField);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Locale = require('../../Locale');

var _Locale2 = _interopRequireDefault(_Locale);

var _reactIntl = require('react-intl');

var _IconPath = require('../../services/IconPath');

var _IconPath2 = _interopRequireDefault(_IconPath);

var _TextField = require('../../managewidgets/components/textfield/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _Image = require('../../managewidgets/components/image/Image');

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchField = function (_React$Component) {
  (0, _inherits3.default)(SearchField, _React$Component);

  function SearchField() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchField);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchField.__proto__ || (0, _getPrototypeOf2.default)(SearchField)).call.apply(_ref, [this].concat(args))), _this), _this.onClear = function () {
      var value = '';
      _this.props.onChange(value);
      _this.textField.focus();
      _this.props.onSearch(value);
    }, _this.handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this.props.onSearch(_this.props.value);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.textField.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var formatMessage = this.props.intl.formatMessage;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(this.props.className, _SearchField2.default.wrap) },
        _react2.default.createElement(_Image2.default, {
          className: (0, _classnames2.default)('CwThemeFill', _SearchField2.default.searchIcon),
          src: _IconPath2.default.get('Action_Search') }),
        _react2.default.createElement(_TextField2.default, {
          ref: function ref(input) {
            return _this2.textField = input;
          },
          automationName: this.props.automationName,
          className: _SearchField2.default.searchField,
          value: this.props.value,
          placeholder: this.props.placeholderText ? this.props.placeholderText : formatMessage(_Locale2.default.search_field),
          onChange: this.props.onChange,
          onKeyPress: this.handleKeyPress,
          onBlur: this.props.onBlur }),
        _react2.default.createElement(_Image2.default, {
          automationName: this.props.automationName + '_clear',
          className: _SearchField2.default.searchClear,
          src: _IconPath2.default.get('Action_Close'),
          onClick: this.onClear })
      );
    }
  }]);
  return SearchField;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(SearchField);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/search/SearchField.js
// module id = 356
// module chunks = 10